import { useEffect, useRef, useState } from 'react';
import { Box, Button, Card, CardContent, Chip, Grid, Pagination, Typography } from '@mui/material';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import api_service from '../../../network/api_callbacks';
import { toast } from 'react-toastify';
import Loader from '../../../utility/Loader';
import QuestionTopToolbar from '../../../components/QuestionManagment/QuestionTopToolbar';
import QuestionShowFilterPane from '../../../components/QuestionManagment/QuestionShowFilterPane';
import QuestionListItem from '../../../components/QuestionManagment/QuestionListItem';
import QuestionListItem2 from '../../../components/QuestionManagment/QuestionListItem2';
import { set } from 'react-hook-form';
import { weightageEnum } from './CreateQuestion';

function QuestionManagment(props) {

    const navigate = useNavigate();
    const location = useLocation();
    const isCreatePage = location.pathname.includes("create-question");
    const pathname = location.pathname;
    const state = location.state;

    //console.log("location : ", location);
    //console.log("location.pathname : ", pathname);
    //console.log("location.state : ", state);

    const DEFAULT_PAGINATION_ITEM_COUNT = 100;
    const DEFAULT_PAGINATION_PAGE = 1;

    const scrollRef = useRef(null);

    const [loader, setLoader] = useState(false);
    const [searchText, setSearchText] = useState('');

    const [showFilter, setShowFilter] = useState(null);
    const [applyFilter, setApplyFilter] = useState(false);

    const [question_filter, setQuestionFilter] = useState(null);
    const [questionsList, setQuestionsList] = useState([]);
    const [page, setPage] = useState(DEFAULT_PAGINATION_PAGE);
    const [pagination_data, setPaginationData] = useState(null);

    const [entityNameFilter, setEntityNameFilter] = useState('');
    const [entityCategoryFilter, setEntityCategoryFilter] = useState([]);
    const [entityDifficultyFilter, setEntityDifficultyFilter] = useState([]);
    const [questionStatusFilter, setQuestionStatusFilter] = useState([]);
    const [gameTypeFilter, setGameTypeFilter] = useState([]);
    const [vimeoIdFilter, setVimeoIdFilter] = useState('');
    const [contentIdFilter, setContentIdFilter] = useState('');
    const [createdAtStartFilter, setCreatedAtStartFilter] = useState(null);
    const [createdAtEndFilter, setCreatedAtEndFilter] = useState(null);
    const [updatedAtStartFilter, setUpdatedAtStartFilter] = useState(null);
    const [updatedAtEndFilter, setUpdatedAtEndFilter] = useState(null);

    const [activeVideoId, setActiveVideoId] = useState(null);

    useEffect(() => {
        if (state?.shouldRefresh) {
            const params = { page: DEFAULT_PAGINATION_PAGE, limit: DEFAULT_PAGINATION_ITEM_COUNT }
            getQuestionsList(params);
            getQuestionsFilters();
        }
    }, [state?.shouldRefresh]);

    useEffect(() => {
        if (!pagination_data && questionsList?.length === 0) {
            const params = { page: DEFAULT_PAGINATION_PAGE, limit: DEFAULT_PAGINATION_ITEM_COUNT }
            getQuestionsList(params);
            getQuestionsFilters();
        }
    }, []);

    // When filter is applied
    useEffect(() => {
        if (applyFilter) {
            callQuestionsListWithSearchAndFilter();
            setApplyFilter(false);
        }
    }, [applyFilter]);

    const getQuestionsList = async (params) => {
        setLoader(true);
        try {
            let response;

            response = await api_service.getQuestionsNew(params);

            const status = response?.status;
            const resData = response?.data;
            const responseCode = response?.responseCode;
            const errorMsg = response?.error?.message;

            if (status === 201 || status === 200 || responseCode === 200 || responseCode === 201) {
                setQuestionsList(resData?.questions || []);
                setPaginationData(resData?.pagination || null);
                setPage(params?.page || DEFAULT_PAGINATION_PAGE);
            }
            else {
                toast.error(`${errorMsg}`)
                console.log('Returning responseCode due to error:', responseCode);
                return responseCode;
            }
            setLoader(false);
        } catch (error) {
            setLoader(false);
            console.error('❌ Failed to fetch getQuestionsNew:', error);
        }
    }

    const getQuestionsFilters = async () => {
        //setLoader(true);
        try {
            const response = await api_service.getQuestionFilterNew({});

            //console.log('📘 getQuestionFilterNew response :', response);

            const status = response?.status;
            const resData = response?.data;
            const responseCode = response?.responseCode;
            const errorMsg = response?.error?.message;

            if (status === 201 || status === 200 || responseCode === 200 || responseCode === 201) {
                setQuestionFilter(resData || null);
            }
            else {
                toast.error(`${errorMsg}`)
                console.log('Returning responseCode due to error:', responseCode);
                return responseCode;
            }

            //console.log('📘 getQuestionFilterNew response :', response);
            //console.log('📘 getQuestionFilterNew status :', status);
            //console.log('📘 getQuestionFilterNew data :', resData);
            //console.log('📘 getQuestionFilterNew responseCode :', responseCode);
            //console.log('📘 getQuestionFilterNew errorMsg :', errorMsg);
            //setLoader(false);
        } catch (error) {
            //setLoader(false);
            console.error('❌ Failed to fetch getQuestionFilterNew:', error);
        }
    }

    const handleClearFilters = () => {
        setSearchText('');

        setEntityNameFilter('');
        setEntityCategoryFilter([]);
        setEntityDifficultyFilter([]);
        setQuestionStatusFilter([]);
        setGameTypeFilter([]);
        setVimeoIdFilter('');
        setContentIdFilter('');
        setCreatedAtStartFilter(null);
        setCreatedAtEndFilter(null);
        setUpdatedAtStartFilter(null);
        setUpdatedAtEndFilter(null);

        setPage(DEFAULT_PAGINATION_PAGE);
        setQuestionsList([]);

        const params = {
            page: DEFAULT_PAGINATION_PAGE,
            limit: DEFAULT_PAGINATION_ITEM_COUNT,
        }
        getQuestionsList(params);
    };

    const handleClearSearch = () => {
        setSearchText('');
        callQuestionsListWithSearchAndFilter(true);
    };

    const navigateToUpdateQuestion = (_question_data, item2) => {
        console.log("navigateToUpdateQuestion - _question_data: ", _question_data);
        console.log("navigateToUpdateQuestion - item2: ", item2);
        setActiveVideoId(null);
        navigate('/questions/create-question', {
            state: {
                question_data: _question_data,
                question_filter: question_filter,
                from: 'questions'
            }
        });
    };

    const navigateToCreateQuestion = () => {
        setActiveVideoId(null);
        navigate('/questions/create-question', {
            state: {
                question_data: null,
                question_filter: question_filter,
                from: 'questions'
            }
        });
    };


    const handleShowFilter = () => {
        setShowFilter(!showFilter)
    };

    const handleCreateUpdateClick = (_question_data) => {
        navigateToUpdateQuestion(_question_data);
    };

    const handleSearch = () => {
        callQuestionsListWithSearchAndFilter();
    }

    const callQuestionsListWithSearchAndFilter = (isSearchClear = false) => {
        setPage(DEFAULT_PAGINATION_PAGE);
        setQuestionsList([]);

        const params = {
            page: DEFAULT_PAGINATION_PAGE,
            limit: DEFAULT_PAGINATION_ITEM_COUNT,
            qText: isSearchClear ? '' : searchText,
            contentId: contentIdFilter,
            entityName: entityNameFilter,
            entityType: entityCategoryFilter,
            difficulty: entityDifficultyFilter,
            status: questionStatusFilter,
            gameType: gameTypeFilter,
            vimeoId: vimeoIdFilter,
            createdStart: createdAtStartFilter,
            createdEnd: createdAtEndFilter,
            modifiedStart: updatedAtStartFilter,
            modifiedEnd: updatedAtEndFilter,
        }

        // Remove empty/null/undefined/empty array keys from params
        const filteredParams = Object.fromEntries(
            Object.entries(params).filter(
                ([, v]) =>
                    v !== null &&
                    v !== undefined &&
                    !(typeof v === 'string' && v.trim() === '') &&
                    !(Array.isArray(v) && v.length === 0)
            )
        );
        console.log('Filtered Params for getQuestionsList on refresh:', filteredParams);

        getQuestionsList(filteredParams);
    }

    return (
        <>
            {!isCreatePage ?
                <Box sx={{
                    flex: 1,
                    height: '100vh',
                    minHeight: 0,
                    display: "flex",
                    padding: 0,
                    flexDirection: "row",
                    gap: 0,
                    overflow: 'hidden', // Prevent parent scrolling
                }}>

                    <Box sx={{ flex: 1, height: "100%", minHeight: 0, display: "flex", marginTop: '6vh', flexDirection: "column", padding: 3, paddingBottom: 0, }}>

                        {/* Top Toolbar: auto height */}
                        <Box sx={{ flex: 0, width: '100%' }}>
                            <QuestionTopToolbar
                                questionCount={pagination_data?.total || 0}
                                searchText={searchText}
                                setSearchText={setSearchText}
                                onCreateClick={navigateToCreateQuestion}
                                onToggleFilter={handleShowFilter}
                                handleSearch={handleSearch}
                                handleClearSearch={handleClearSearch}
                            />
                        </Box>

                        {/* Grid area: fills all remaining space */}
                        <Box sx={{ flex: 1, minHeight: '75%', overflow: 'auto', display: 'flex', flexDirection: 'column' }}>
                            <Grid container spacing={2} justifyContent="center" alignItems="center" marginBottom={0} style={{ flex: 1 }}>
                                {questionsList?.map((item) => {
                                    const item2 = {
                                        videoUrl: item.multimedia?.url,
                                        id: item.questionId,
                                        contentId: item.contentId,
                                        difficulty: item.difficulty === 0 ? 'Easy' : item.difficulty === 1 ? 'Medium' : 'Difficult',
                                        vimeoId: item.multimedia?.url?.split('/').pop(),
                                        form: item.multimedia?.form,
                                        status: item.status,
                                        gameType: item.gameType?.join(' / '),
                                        questionText: item.questionText,
                                        options: item.options.map(opt => ({
                                            ...opt,
                                            isCorrect: item.answer.some(ans => ans.id === opt.id)
                                        })),
                                        entity: {
                                            name: item.entities?.[0]?.displayName,
                                            id: item.entities?.[0]?.entityId,
                                            type: item.entities?.[0]?.entityType,
                                            weightage: weightageEnum[item.entities?.[0]?.weightage],
                                            imageUrl: item.entities?.[0]?.displayImage
                                        }
                                    };

                                    return (
                                        <QuestionListItem2
                                            key={item2?.id}
                                            item={item2}
                                            isActive={activeVideoId === item2?.id}
                                            onPlay={() => setActiveVideoId(item2?.id)}
                                            onClick={() => navigateToUpdateQuestion(item, item2)}
                                        />
                                    )
                                })}
                            </Grid>
                        </Box>

                        {/* Pagination: auto height */}
                        <Box sx={{ flex: 0.18, display: "flex", height: 'auto', justifyContent: "center", mt: 0 }}>
                            {pagination_data && (
                                <Pagination
                                    count={pagination_data?.totalPages || 1}
                                    page={page}
                                    onChange={(_, newPage) => {
                                        const params = { page: newPage, limit: DEFAULT_PAGINATION_ITEM_COUNT }
                                        getQuestionsList(params)
                                    }}
                                    color="primary"
                                    size="large"
                                    variant="outlined"
                                    shape="rounded"
                                    sx={{
                                        mt: 2,
                                        "& .MuiPaginationItem-root": {
                                            borderRadius: "8px",
                                            fontWeight: "bold",
                                            color: "#444",
                                        },
                                        "& .Mui-selected": {
                                            backgroundColor: "#1976d2 !important",
                                            color: "#fff",
                                            boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                                        },
                                        "& .MuiPaginationItem-root:hover": {
                                            backgroundColor: "rgba(25, 118, 210, 0.1)",
                                        },
                                    }}
                                />
                            )}
                        </Box>
                    </Box>

                    <QuestionShowFilterPane
                        question_data={questionsList}
                        question_filter={question_filter}
                        showFilter={showFilter}
                        setShowFilter={setShowFilter}
                        applyFilter={applyFilter}
                        setApplyFilter={setApplyFilter}
                        handleClearFilters={handleClearFilters}
                        entityNameFilter={entityNameFilter}
                        setEntityNameFilter={setEntityNameFilter}
                        entityCategoryFilter={entityCategoryFilter}
                        setEntityCategoryFilter={setEntityCategoryFilter}
                        entityDifficultyFilter={entityDifficultyFilter}
                        setEntityDifficultyFilter={setEntityDifficultyFilter}
                        questionStatusFilter={questionStatusFilter}
                        setQuestionStatusFilter={setQuestionStatusFilter}
                        gameTypeFilter={gameTypeFilter}
                        setGameTypeFilter={setGameTypeFilter}
                        vimeoIdFilter={vimeoIdFilter}
                        setVimeoIdFilter={setVimeoIdFilter}
                        contentIdFilter={contentIdFilter}
                        setContentIdFilter={setContentIdFilter}
                        createdAtStartFilter={createdAtStartFilter}
                        setCreatedAtStartFilter={setCreatedAtStartFilter}
                        createdAtEndFilter={createdAtEndFilter}
                        setCreatedAtEndFilter={setCreatedAtEndFilter}
                        updatedAtStartFilter={updatedAtStartFilter}
                        setUpdatedAtStartFilter={setUpdatedAtStartFilter}
                        updatedAtEndFilter={updatedAtEndFilter}
                        setUpdatedAtEndFilter={setUpdatedAtEndFilter}
                    />

                    {/* ✅ Loader overlay in center */}
                    {loader && (
                        <Box
                            sx={{
                                position: "fixed", // ✅ fixed to viewport
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                background: "rgba(255,255,255,0.6)",
                                zIndex: 1300, // higher than sticky header

                                // position: "absolute",
                                // top: "50%",
                                // left: "50%",
                                // transform: "translate(-50%, -50%)", // ✅ Center correctly
                                // display: "flex",
                                // justifyContent: "center",
                                // alignItems: "center",
                                // background: "rgba(255,255,255,0.6)",
                                // zIndex: 10,
                                // width: "100%",
                                // height: "100%",
                            }}
                        >
                            <Loader />
                        </Box>)}
                </Box>
                :
                <Outlet />}
        </>
    );
}

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'row',
        height: '100vh',
        padding: '40px 0px',
        textAlign: 'center',
        boxSizing: 'border-box',
        overflow: 'hidden',
    },
    title: {
        fontSize: '36px',
        marginBottom: '10px',
    },
};

export default QuestionManagment;